import { Component, OnInit, Input } from '@angular/core';
import { RDDarkService } from '../dark.service';

@Component({
  selector: 'rd-progress-bar',
  template: `<div class="progressBar {{color}}" [class.rdDark]="dark" [style.height.px]="height + 12">
  <span class="progression" [style.width.%]="width">
    <span *ngIf="display" id="progressText">{{width}}%</span>
  </span>
</div>
`,
  styles: [`.progressBar{--main-color:#ba9e5a;--background-color:#f1f1f1;width:100%;background-color:var(--background-color);border-radius:13px;box-shadow:0 2px 5px 0 rgba(0,0,0,.16),0 2px 10px 0 rgba(0,0,0,.12);box-sizing:border-box;padding:6px;transition:all .3s linear}.progressBar .progression{display:block;height:100%;background-color:var(--main-color);box-shadow:inset 0 2px 6px rgba(255,255,255,.3),inset 0 -2px 3px rgba(0,0,0,.4);position:relative;overflow:hidden;border-radius:20px}.progressBar .progression:after{content:"";position:absolute;top:0;left:0;bottom:0;right:0;background-image:linear-gradient(-45deg,rgba(255,255,255,.2) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.2) 50%,rgba(255,255,255,.2) 75%,transparent 75%,transparent);z-index:1;background-size:50px 50px;-webkit-animation:2s linear infinite move;animation:2s linear infinite move;overflow:hidden;border-radius:20px 8px 8px 20px}.progressBar #progressText{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);color:#fff}.progressBar.blue{--main-color:#5a5aba}.progressBar.blue-light{--main-color:#5aa2ba}.progressBar.red{--main-color:#ba5a5a}.progressBar.green{--main-color:#72ba5a}.progressBar.orange{--main-color:#ba8a5a}.progressBar.purple{--main-color:#a25aba}.progressBar.rdDark{--background-color:#07384c}@-webkit-keyframes move{0%{background-position:0 0}100%{background-position:50px 50px}}@keyframes move{0%{background-position:0 0}100%{background-position:50px 50px}}`]
})
export class RDProgressBarComponent implements OnInit {

  @Input() width = 50;
  @Input() height = 15;
  @Input() color = 'gold';
  @Input() display = false;

  public dark = false;

  constructor(private darkService: RDDarkService) { }

  ngOnInit() {
    this.darkService.getDarkElement().subscribe(() => {
      this.dark = this.darkService.isDark();
    });
    this.dark = this.darkService.isDark();
  }

}
